module.exports = __webpack_public_path__ + "img/lens-167-minus-09.98837aa7.png";